import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";
import { Question } from "@phosphor-icons/react";

// Auto-loads FAQs for the given category (or general FAQs when no category).
export function FaqSection({ category = "" }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get("/public/faqs", { params: category ? { category } : {} })
      .then(({ data }) => { if (active) setItems(data.items || []); })
      .catch(() => { if (active) setItems([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [category]);

  if (loading || items.length === 0) return null;

  return (
    <section className="mt-16 border-t border-[#E2E8F0] pt-12" data-testid="faq-section">
      <div className="flex items-center gap-2 mb-6">
        <Question size={26} weight="fill" className="text-[#4F46E5]" />
        <h2 className="font-[Outfit] text-2xl font-extrabold tracking-tight">
          {category ? `${category} — Frequently Asked Questions` : "Frequently Asked Questions"}
        </h2>
      </div>
      <Accordion type="single" collapsible className="max-w-3xl">
        {items.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left font-semibold text-[#1e293b]">{f.q}</AccordionTrigger>
            <AccordionContent className="text-[#475569] leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
